import { render } from "./Coctails.vue?vue&type=template&id=3bb1d368&scoped=true"
import script from "./Coctails.vue?vue&type=script&lang=js"
export * from "./Coctails.vue?vue&type=script&lang=js"

import "./Coctails.vue?vue&type=style&index=0&id=3bb1d368&lang=scss&scoped=true"

import exportComponent from "../../../../../DIARC/pixonanimation.az/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bb1d368"]])

export default __exports__